export default __webpack_public_path__ + "static/media/stash-icon.dcd7b76f.png";